<script setup lang="ts">
import type { CmsElementZebraCmsFaq } from "~/composables/useCustom";
import 'vue3-carousel/dist/carousel.css'

const props = defineProps<{
  content: CmsElementZebraCmsFaq;
}>();

const { Link, appImage, iosLink, iosImage } = props.content?.config

</script>

<template>
  <div class="download-store">
    <div class="container">
      <div class="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-0 md:space-x-3">
        <a v-if="Link && appImage && Link.value && appImage.value" :href="Link.value.url" class="block"><img :src="appImage.value.url" alt="Google Play"></a>
        <a v-if="iosImage && iosLink && iosImage.value && iosLink.value" :href="iosLink.value.url" class="block"><img :src="iosImage.value.url" alt="App Play"></a>
      </div>
    </div>
  </div>
</template>
